import { Box, Typography, styled } from "@mui/material";

export function ItemInformation({ tooltip, information, title, color }) {
  return (
    <BoxInformation>
      <Typography variant="h6" color={color}>
        {tooltip}
        <Typography variant="span">{information}</Typography>
      </Typography>

      <Typography variant="h6" color="text.secondary">
        {title}
      </Typography>
    </BoxInformation>
  );
}

const BoxInformation = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(1),

  "&:last-child": {
    borderBottom: "none",
    paddingBottom: 0,
    marginBottom: 0,
  },

  "ion-icon": {
    fontSize: "14px",
    color: theme.palette.secondary.main,
  },
}));

export default ItemInformation;
